module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:right",
      value: ({
        html: 'Usar esta opción cuando no se tenga el documento del huésped.'
      }),
      expression: "{ html: 'Usar esta opción cuando no se tenga el documento del huésped.' }",
      arg: "right"
    }],
    staticClass: "input-checkbox input-booking generic-checkbox",
    attrs: {
      "label": "Cliente Genérico",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.customer.flagGeneric),
      callback: function($$v) {
        _vm.customer.flagGeneric = $$v
      },
      expression: "customer.flagGeneric"
    }
  })], 1)], 1), _vm._v(" "), (_vm.genericCustomer) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Tarjeta")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('select-button', {
    staticClass: "filter-select filter-select-indicator",
    attrs: {
      "item-text": "name",
      "item-value": "id",
      "items": _vm.typeCards
    },
    model: {
      value: (_vm.typeCard),
      callback: function($$v) {
        _vm.typeCard = $$v
      },
      expression: "typeCard"
    }
  }), _vm._v(" "), _c('input-text', {
    model: {
      value: (_vm.customer.cardVip),
      callback: function($$v) {
        _vm.customer.cardVip = $$v
      },
      expression: "customer.cardVip"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": "",
      "txt-xs-left": ""
    }
  }, [_c('type-document-input', {
    attrs: {
      "label-text": "Tipo de identificación",
      "subsidiary": _vm.subsidiaryId
    },
    on: {
      "customer-not-found": _vm.customerNotFound,
      "customer-data": _vm.setCustomer
    }
  }), _vm._v(" "), (_vm.$v.customer.entity.documentType && _vm.$v.customer.entity.documentType.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl tipo de documento es requerido.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.customer.entity.numDocument && _vm.$v.customer.entity.numDocument.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.customer.entity.numDocument && _vm.$v.customer.entity.numDocument.$invalid &&
    _vm.$v.customer.entity.numDocument.$params.minLength) ? _c('p', {
    staticClass: "caption red--text mb-0"
  }, [_vm._v("\n\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.customer.entity.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    class: {
      'xs6': !_vm.isNaturalPerson
    },
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": _vm.nameLabel,
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.name),
      callback: function($$v) {
        _vm.customer.name = $$v
      },
      expression: "customer.name"
    }
  }), _vm._v(" "), (_vm.$v.customer.name && _vm.$v.customer.name.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.nameMessage) + "\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Apellidos",
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.lastname),
      callback: function($$v) {
        _vm.customer.lastname = $$v
      },
      expression: "customer.lastname"
    }
  }), _vm._v(" "), (_vm.$v.customer.lastname && _vm.$v.customer.lastname.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "email",
      "label-text": "Correo electrónico",
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.email),
      callback: function($$v) {
        _vm.customer.email = $$v
      },
      expression: "customer.email"
    }
  }), _vm._v(" "), (_vm.$v.customer.email && _vm.$v.customer.email.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tCorreo inválido\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.showCustomerRate) ? _c('v-flex', {
    staticClass: "customer-rate",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save mt-4",
    on: {
      "click": _vm.onShowRateModal
    }
  }, [_vm._v("Tarifario")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.flagShowRateModal) ? _c('rate-modal', {
    staticClass: "rate-modal",
    attrs: {
      "subsidiary-id": _vm.subsidiaryId,
      "customer-whith-rate": _vm.showCustomerRate,
      "rates": _vm.rateAvailability
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.genericCustomer) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pa-0": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-regular input-label-select",
    attrs: {
      "value": "Adulto",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "py-0": "",
      "pl-0": ""
    }
  }, [_c('select-date', {
    attrs: {
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.dateBirth),
      callback: function($$v) {
        _vm.customer.dateBirth = $$v
      },
      expression: "customer.dateBirth"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label-text": "Estado civil",
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.customer.entity.numDocument,
      "items": _vm.civilStatus
    },
    model: {
      value: (_vm.customer.civilStatus),
      callback: function($$v) {
        _vm.customer.civilStatus = $$v
      },
      expression: "customer.civilStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label-text": "Género",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.genders,
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.gender),
      callback: function($$v) {
        _vm.customer.gender = $$v
      },
      expression: "customer.gender"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label-text": "País",
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.customer.entity.numDocument,
      "items": _vm.countries
    },
    on: {
      "input": _vm.loadCities
    },
    model: {
      value: (_vm.customer.countryId),
      callback: function($$v) {
        _vm.customer.countryId = $$v
      },
      expression: "customer.countryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label-text": "Ciudad",
      "item-text": "province",
      "item-value": "id",
      "disabled": !_vm.customer.entity.numDocument,
      "items": _vm.citiesByCountry
    },
    model: {
      value: (_vm.customer.cityId),
      callback: function($$v) {
        _vm.customer.cityId = $$v
      },
      expression: "customer.cityId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "tel",
      "label-text": "Teléfono",
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.phone),
      callback: function($$v) {
        _vm.customer.phone = $$v
      },
      expression: "customer.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mb-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "tel",
      "label-text": "Dirección",
      "disabled": !_vm.customer.entity.numDocument
    },
    model: {
      value: (_vm.customer.address),
      callback: function($$v) {
        _vm.customer.address = $$v
      },
      expression: "customer.address"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90884c7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/GenericCustomerComponent.vue
// module id = 1683
// module chunks = 20